import React from 'react';
import { FaUserShield } from 'react-icons/fa';

const AdminHeader = ({ title, subtitle, onSignOut }) => {
  return (
    <header className="flex flex-col items-start justify-between gap-4 border-b border-[#262626] bg-[#111] px-4 py-4 sm:flex-row sm:items-center sm:px-5">
      <div>
        <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#EEC24B]">Admin Control</p>
        <h1 className="mt-[0.25rem] text-[24px] font-bold text-white">{title}</h1>
        {subtitle ? <p className="mt-[0.2rem] text-[14px] text-[#BDBDBD]">{subtitle}</p> : null}
      </div>
      <button
        type="button"
        onClick={onSignOut}
        className="inline-flex min-h-11 items-center gap-[0.55rem] rounded-lg border border-[#262626] px-4 py-3 text-[14px] font-semibold text-white transition-colors hover:border-[#EEC24B]"
      >
        <FaUserShield />
        Sign out
      </button>
    </header>
  );
};

export default AdminHeader;
